import styled from "styled-components";

const FeeSectionCss = styled.div`
  font-family: "Poppins";
  text-align: center;
  align-items: center;
  color: white;
  background: linear-gradient(180deg, #255862 0%, #163940 53.12%, #0a171a 100%);
  .wrapper {
    display: flex;
    justify-content: space-around;
    .left {
      @media (max-width: 800px) {
        display: none;
      }
      flex: 0.5;
      width: 50%;
      // margin-left: -4rem;
      padding-bottom: 5rem;
      .title {
        padding-left: 17%;
        padding-top: 5rem;
        text-align: left;
        color: white;
        font-family: Poppins;
        font-size: 40px;
        font-style: normal;
        font-weight: 300;
        line-height: 60px;
        letter-spacing: 0em;
        text-align: left;
      }
      .stat {
        padding-left: 17%;

        h3 {
          color: #fdcd0b;
          font-family: Poppins;
          font-size: 44px;
          font-style: normal;
          font-weight: 300;
          line-height: 66px;
          letter-spacing: 0em;
          text-align: left;
        }
        p {
          font-family: Poppins;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: 27px;
          letter-spacing: 0em;
          text-align: left;
        }
      }
      .buttons {
        display: flex;
        justify-content: space-around;
        width: 80%;

        @media (max-width: 950px) {
          width: 90%;
        }
        padding-left: 17%;
        .leftButton {
          // width: 23rem;
          font-family: "Poppins";
          height: 5rem;
          margin-right: 1rem;
          margin-top: 2rem;
          font-weight: 500;
          font-size: 24px;
          line-height: 39px;
          border-radius: 15px;
          color: #1c454c;
          flex: 0.5;
          background-color: #fdcd0b;
          &:hover {
            span {
              transition: transform 0.3s;
              transform: scale(1.07);
            }
          }
          @media (max-width: 1700px) {
            height: 3rem;
            font-size: 16px;
            line-height: 25px;
            width: 40rem;
            border-radius: 12px;
          }
          @media (max-width: 1300px) {
            font-size: 12px;
          }

          @media (max-width: 950px) {
            font-size: 14px;
          }
        }

        .rightButton {
          font-family: "Poppins";

          // width: 29rem;
          height: 5rem;
          margin-top: 2rem;
          font-weight: 400;
          font-size: 24px;
          line-height: 39px;
          border-radius: 15px;
          color: #fdcd0b;
          flex: 0.5;
          border: 1px solid #fdcd0b;
          background-color: transparent;
          transition: transform 0.3s;
          &:hover {
            span {
              transition: transform 0.3s;
              transform: scale(1.06);
            }
          }
          @media (max-width: 1700px) {
            height: 3rem;
            font-size: 16px;
            line-height: 20px;
            width: 40rem;
            border-radius: 12px;
          }
          @media (max-width: 1300px) {
            font-size: 12px;
          }
          @media (max-width: 1100px) {
            width: 40vw;
          }
          @media (max-width: 950px) {
            font-size: 12px;
          }
        }
      }
      .text {
        padding-left: 17%;
        padding-right: 3rem;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .right {
      @media (max-width: 800px) {
        display: none;
      }
      padding-bottom: 5rem;
      padding-right: 1rem;
      flex: 0.5;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .up {
        border-left: 1px solid #fdcd0b;
        margin-top: 5rem;

        .header {
          padding-left: 3rem;
          padding-bottom: 1rem;
          font-family: Poppins;
          font-size: 65px;
          font-style: normal;
          font-weight: 500;
          line-height: 50px;
          letter-spacing: 0em;
          text-align: left;
          color: #fdcd0b;

          @media (max-width: 1700px) {
            font-size: 50px;
            line-height: 35px;
          }
        }
        .subheader {
          padding-left: 3rem;
          color: #fdcd0b;
          font-family: Poppins;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 50px;
          letter-spacing: 0em;
          text-align: left;

          @media (max-width: 1700px) {
            font-size: 20px;
            line-height: 30px;
          }
        }
        .text {
          padding-left: 4rem;
          font-family: Poppins;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 50px;
          letter-spacing: 0em;
          text-align: left;

          @media (max-width: 1700px) {
            font-size: 14px;
            line-height: 30px;
          }
        }
      }
      .down {
        /* margin-bottom: 5rem; */
        border-left: 1px solid #fdcd0b;

        .header {
          padding-left: 3rem;
          padding-bottom: 1rem;

          margin-top: 2rem;
          font-family: Poppins;
          font-size: 65px;
          font-style: normal;
          font-weight: 500;
          line-height: 50px;
          letter-spacing: 0em;
          text-align: left;
          color: #fdcd0b;

          @media (max-width: 1700px) {
            font-size: 50px;
            line-height: 35px;
          }
        }

        .subheader {
          padding-left: 3rem;
          color: #fdcd0b;
          font-family: Poppins;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 50px;
          letter-spacing: 0em;
          text-align: left;
          @media (max-width: 1700px) {
            font-size: 20px;
            line-height: 30px;
          }
        }

        .text {
          padding-left: 4rem;
          font-family: Poppins;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 50px;
          letter-spacing: 0em;
          text-align: left;

          @media (max-width: 1700px) {
            font-size: 14px;
            line-height: 30px;
          }
        }
      }
    }
    .mobile {
      display: none;
      @media (max-width: 800px) {
        display: flex;
      }
      flex-direction: column;
      justify-content: space-around;
      .top_mob {
        .title_mob {
          font-family: Poppins;
          font-size: 40px;
          font-style: normal;
          font-weight: 300;
          line-height: 60px;
          letter-spacing: 0em;
          text-align: center;
          color: white;
          padding-top: 2rem;
          padding-bottom: 1rem;
          @media (max-width: 800px) {
            font-size: 30px;
          }
          @media (max-width: 600px) {
            font-size: 26px;
          }
        }
        .subtitle {
          h3 {
            font-family: Poppins;
            font-size: 32px;
            font-style: normal;
            font-weight: 300;
            line-height: 40px;
            letter-spacing: 0em;
            text-align: center;
            color: #fdcd0b;
            padding-bottom: 0;
          }
          p {
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 350;
            line-height: 27px;
            letter-spacing: 0em;
            text-align: center;
            color: white;
          }
        }
        .buttons {
          padding: 0 2rem 0 2rem;
          .leftButton {
            font-family: "Poppins";
            height: 3rem;
            margin-right: 1rem;
            // margin-top: 2rem;
            font-weight: 500;
            font-size: 18px;
            line-height: 20px;
            border-radius: 9px;
            color: #1c454c;
            flex: 0.5;
            background-color: #fdcd0b;
            &:hover {
              span {
                transition: transform 0.3s;
                transform: scale(1.07);
              }
            }
            @media (max-width: 450px) {
              font-size: 13px;
              font-weight: 550;
              line-height: 18px;
            }
          }
          .rightButton {
            font-family: "Poppins";

            height: 3rem;
            // margin-top: 2rem;
            font-weight: 400;
            font-size: 18px;
            line-height: 20px;
            border-radius: 9px;
            color: #fdcd0b;
            flex: 0.5;
            border: 1px solid #fdcd0b;
            background-color: transparent;
            transition: transform 0.3s;
            &:hover {
              span {
                transition: transform 0.3s;
                transform: scale(1.06);
              }
            }
            @media (max-width: 450px) {
              font-size: 13px;
              line-height: 18px;
            }
          }
        }
      }
      .middle_mob {
        margin-top: 2rem;
        padding: 1rem 2rem;
        .up {
          border-left: 1px solid #fdcd0b;
          .header {
            padding-left: 1rem;
            padding-bottom: 1rem;
            font-family: Poppins;
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
            line-height: 40px;
            letter-spacing: 0em;
            text-align: left;
            color: #fdcd0b;
          }
          .subheader {
            padding-left: 1rem;
            color: #fdcd0b;
            font-family: Poppins;
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: 35px;
            letter-spacing: 0em;
            text-align: left;
          }
          .text {
            padding-left: 2rem;
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 30px;
            letter-spacing: 0em;
            text-align: left;
          }
        }
        .down {
          /* margin-bottom: 5rem; */
          border-left: 1px solid #fdcd0b;

          .header {
            padding-left: 1rem;
            padding-bottom: 1rem;

            margin-top: 2rem;
            font-family: Poppins;
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
            line-height: 40px;
            letter-spacing: 0em;
            text-align: left;
            color: #fdcd0b;
          }

          .subheader {
            padding-left: 1rem;
            color: #fdcd0b;
            font-family: Poppins;
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: 35px;
            letter-spacing: 0em;
            text-align: left;
          }

          .text {
            padding-left: 2rem;
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 30px;
            letter-spacing: 0em;
            text-align: left;
          }
        }
      }
    }
  }
`;

export default FeeSectionCss;
